<template>
  <div class="card">
    <h3>Dashboard</h3>
    <span>
      Bienvenidos al Dashboard de Indicadores y Datos Estadísticos, una
      herramienta diseñada para proporcionar una visión completa y detallada de
      la situación actual en áreas clave como la salud, la educación, el
      presupuesto y más. Además de ello descargue la información en excel para
      crear su propia estadistica</span
    >
    <!-- <div class="row">
      <div class="p-col-12 text-right">
        <Button
          label="Descargar Excel"
          icon="pi pi-check"
          class="p-button-success"
          @click="downloadExcel()"
        />
      </div>
      <div class="p-col-12">
        <iframe
          title="BI_EjecucionPresupuesto_inv"
          width="1366px"
          height="768px"
          src="https://app.powerbi.com/view?r=eyJrIjoiMTVkNjE0NGQtMDlhMS00YTUwLWE0MDYtZTIxNWY4YjIwYjU3IiwidCI6IjE3OWJkZGE4LWQ5NjQtNDNmZi1hZDNiLTY3NDE4NmEyZmEyOCIsImMiOjR9&pageName=ReportSection0a21e955bd272d89e4b7"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </div> -->
  </div>
  <!-- <button @click="rightNow()">GET TO INFO</button>
    
    <div v-if="isLoading" class="p-d-flex p-jc-center">
      <div class="p-mt-6">
        <span>Cargando</span>
      </div>
    </div> -->

  <!--  <div class="p-grid p-fluid dashboard" v-for="(item, key) in items" :key="key">
    <div class="p-col-12 p-md-6 p-xl-3" style="cursor: pointer">
      <router-link :to="click(item)">
        <div class="highlight-box">
          <div
            class="initials"
            v-bind:style="{ color: style(), 'background-color': style() }"
          >
            <span><i style="font-size: 40px" :class="item.icon"></i></span>
          </div>

          <div class="highlight-details">
            <i class="pi pi-fw pi-arrow-right"></i>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </router-link>
    </div>
  </div> -->
</template>

<script>
import { mapGetters } from "vuex";
/* import { useEdutionStore } from "@/store/educacion/educacion"; */
/* import { usePresupuestoStore } from "@/store/presupuesto/presupuesto"; */

export default {
  data() {
    return {
      isLoading: false,
    };
  },
  productService: null,
  eventService: null,

  mounted() {},
  methods: {
    style() {
      let randomColor = Math.floor(Math.random() * 16777215).toString(16);
      let color = "#" + randomColor;
      return color;
    },
    click(item) {
      let href = "#";
      if (item.items != undefined && item.items != "undefined") {
        let child = item.items[0];

        if (child.items.length == 0) {
          href = item.to;
        } else {
          if (child.items != undefined && child.items != "undefined") {
            let subMenu = child.items[0];
            href = subMenu.to;
          }
        }
      }
      return href;
    },
    async rightNow() {
      this.isLoading = true;
      /*   const eduStore = useEdutionStore(); */

      this.isLoading = false;
    },
    async downloadExcel() {
      // const presupuestoStore = usePresupuestoStore();
      //wait presupuestoStore.downloadGastosExcel();
      /* open blank http       */
      window.open(
        "http://localhost:3000/presupuesto/gastos/download",
        "_blank"
      );
    },
  },
  computed: {
    ...mapGetters({ items: "gsdialogoauth/getMenu" }),
  },
};
</script>
